import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import SectionCard from '@Guidelines/Component/SectionCard';
import type SubjectTypeDefinitionFormData from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import SpeakerRoleRow from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/Sections/SpeakerRoles/SpeakerRoleRow';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly formData: SubjectTypeDefinitionFormData;
	readonly onChange: (
		update: (formData: SubjectTypeDefinitionFormData) => SubjectTypeDefinitionFormData,
	) => void;
	readonly isReadOnly: boolean;
};

/** The roles a transcript speaker can take for a dossier of this type. */
const SpeakerRolesSection: React.FC<Props> = ({ formData, onChange, isReadOnly }) => {
	const serverMessage = formData.getSpeakerRolesServerMessage();

	const handleAddClick = React.useCallback(() => {
		onChange((current) => current.addSpeakerRole(''));
	}, [onChange]);

	return (
		<SectionCard title="Rôles de locuteurs" description="Sans rôle, un locuteur s'attribue librement.">
			{formData.speakerRoles.map((role, index) => (
				<SpeakerRoleRow
					// biome-ignore lint/suspicious/noArrayIndexKey: a role being typed has no identity besides its rank
					key={index}
					formData={formData}
					onChange={onChange}
					index={index}
					role={role}
					isReadOnly={isReadOnly}
				/>
			))}
			<ConditionalLoader data={serverMessage}>
				{(message) => <small className="ui-kit-field-error">{message}</small>}
			</ConditionalLoader>
			<div>
				<Button
					type="button"
					size="sm"
					severity="secondary"
					icon={<Plus size={16} />}
					label="Ajouter un rôle"
					disabled={isReadOnly}
					onClick={handleAddClick}
				/>
			</div>
		</SectionCard>
	);
};

export default SpeakerRolesSection;
